document.addEventListener('DOMContentLoaded', function () {
  var a = document.querySelectorAll('a');
  for (var i = 0; i < a.length; i++) {
    var href = a[i].getAttribute('href');
    if (href && /\.(pdf|gif|jpg|png|webp|mp3|mp4|epub)/i.test(href)) {
      a[i].setAttribute('download', '');
    }
  }
});
